export const initialValues = {
	email: "",
	name: "",
	surname: "",
	postal_code: "",
	phone_number: "",
	vat_number: "",
	logo: "",
};
